import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';

const firebaseConfig = {
  apiKey: "AIzaSyCnvgBjkPM2A14eNgGcwFp4LtEXN5gsd4o",
  authDomain: "pocotalk-85885.firebaseapp.com",
  projectId: "pocotalk-85885",
  storageBucket: "pocotalk-85885.firebasestorage.app",
  messagingSenderId: "127608022078",
  appId: "1:127608022078:web:a19f0ce3149a1212a4dd6f",
  measurementId: "G-378V7T3MPQ"
};

// Firebase 초기화
const app = initializeApp(firebaseConfig);

// Firestore 데이터베이스 초기화
export const db = getFirestore(app);

export default app;
